import { StoryblokComponent } from '@storyblok/react';

import Footer from '@/components/layouts/Footer';
import { GalleryOverlay } from '@/components/layouts/GalleryGrid';
import Header from '@/components/layouts/Header';
import Hero from '@/components/layouts/Hero';
import ShareLayout from '@/components/layouts/ShareLayout';

const StoryPost = ({ story, blok, settingsHeader, settingsFooter }) => {
  return (
    <>
      <Hero story={story} blok={blok} type="story">
        <Header theme={'light'} settingsHeader={settingsHeader} />
      </Hero>
      <main role="main" id="main">
        {blok.body
          ? blok.body.map((blk) => (
              <StoryblokComponent blok={blk} key={blk._uid} />
            ))
          : null}
        {/* <Author blok={blok} /> */}
        <ShareLayout blok={blok} />
      </main>
      <Footer settingsFooter={settingsFooter} />
      <GalleryOverlay bloks={blok.body} />
    </>
  );
};

export default StoryPost;
